"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMentions;
exports.useConfigureMentions = exports.configureMentions = exports.fetchSuggestions = exports.formatAcceptedSuggestion = exports.formatSuggestions = void 0;

var _react = require("react");

var _peopleGraphSdk = require("@ccx-public/people-graph-sdk");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _utils = require("../lib/utils");

var _constants = require("../constants");

var _AppContext = _interopRequireDefault(require("../context/AppContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var peopleGraphClient = new _peopleGraphSdk.Client();
var delaySuggestions = 0;
var timerSuggestions;
var retryAfterStatusCodes = [429, 503]; // 301 status code can also have Retry-After header in future

/**
 * getRetryAfterSeconds - reads Retry-After from response header and returns value in milliseconds
 * @param {Object} response - api response object
 * @return {Number} retryAfterValue - Retry-After header value in milliseconds
 */

var getRetryAfterValue = function getRetryAfterValue(response) {
  if (!response || !response.headers) return 0;
  var retryAfterHeader = response.headers.get('Retry-After');
  if (!retryAfterHeader) return 0;
  var retryAfterValue = parseInt(retryAfterHeader, 10);

  if (Number.isFinite(retryAfterValue)) {
    return retryAfterValue * 1000;
  }

  return 0;
};

var formatSuggestions = function formatSuggestions() {
  var suggestions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (// export for testing
    suggestions.map(function (suggestion) {
      var caption = (0, _lodash.default)(suggestion, 'caption');
      return {
        // Caption may be an email but it isn't reliable - must be checked
        email: (0, _utils.isValidEmail)(caption) ? caption : '',
        src: (0, _lodash.default)(suggestion, '_links.thumbnail.href'),
        name: (0, _lodash.default)(suggestion, 'title'),
        token: (0, _lodash.default)(suggestion, 'token'),
        tags: (0, _lodash.default)(suggestion, 'tags'),
        type: (0, _lodash.default)(suggestion, 'type'),
        orgName: (0, _lodash.default)(suggestion, 'organization') || ''
      };
    })
  );
};

exports.formatSuggestions = formatSuggestions;

var formatAcceptedSuggestion = function formatAcceptedSuggestion() {
  var accepted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (// export for testing
    {
      addressBookUrn: (0, _lodash.default)(accepted, 'addressBookUrn'),
      id: (0, _lodash.default)(accepted, 'linkedIdentity'),
      email: (0, _lodash.default)(accepted, 'email')
    }
  );
};
/**
 * fetchSuggestions - Gets list of suggestions from People Graph Service for the provided search text
 * @param {String} searchText - search text that you want to get a suggestion for
 * @param {Object} assetData - asset data object
 * @param {String} shareStatus - string indicating the share status of the asset
 * @return {Array} - People Graph results
 */


exports.formatAcceptedSuggestion = formatAcceptedSuggestion;

var fetchSuggestions = function fetchSuggestions() {
  var searchText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var assetData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var shareStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unshared';

  if (delaySuggestions > 0) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject();
  } // export for testing
  // Assemble the request data


  var request = {
    peopleType: 'PERSON',
    // Ensures no groups are returned
    relationship: 'MENTION',
    resourceType: assetData.type,
    resourceUrn: assetData.id,
    resourceUrl: assetData.url,
    searchText: searchText,
    tags: ['OWNER', 'COLLABORATOR']
  };

  if (shareStatus === 'public' || shareStatus === 'orgShared') {
    request.tags.push('ANNOTATOR');
  }

  return peopleGraphClient.getSuggestions(request).then(function (response) {
    if (response && response.error) {
      throw response;
    }

    return formatSuggestions(response);
  }).catch(function (error) {
    var _error$response;

    if (retryAfterStatusCodes.includes(error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status)) {
      delaySuggestions = getRetryAfterValue(error.response);
      clearTimeout(timerSuggestions);
      timerSuggestions = setTimeout(function () {
        delaySuggestions = 0;
      }, delaySuggestions);
    }

    console.warn(error); // Ensure that we stop showing potentially incorrect suggestions

    return [];
  });
};

exports.fetchSuggestions = fetchSuggestions;

var configureMentions = function configureMentions(imsData, shareStatus, environment, peopleGraphAPIKey, assetData) {
  var env = environment === 'mock' || environment === 'dev' ? 'stage' : environment;
  var config = {
    apiKey: peopleGraphAPIKey,
    environment: env,
    token: imsData === null || imsData === void 0 ? void 0 : imsData.token,
    acceptHeaderVersion: 'V2'
  };
  peopleGraphClient.configure(config).then(function () {
    // Warm the PGC cache with a blank query
    fetchSuggestions('', assetData, shareStatus);
  });
};

exports.configureMentions = configureMentions;

var useConfigureMentions = function useConfigureMentions() {
  var _useContext = (0, _react.useContext)(_AppContext.default),
      assetData = _useContext.assetData,
      imsData = _useContext.imsData,
      environment = _useContext.environment,
      mentionsEnabled = _useContext.mentionsEnabled,
      peopleGraphAPIKey = _useContext.peopleGraphAPIKey,
      shareStatus = _useContext.shareStatus; // Configure mentions based on IMS data


  (0, _react.useEffect)(function () {
    // Only configure mentions if we have IMS data (no guest usage)
    if (imsData.token && !imsData.isGuestUser) {
      configureMentions(imsData, shareStatus, environment, peopleGraphAPIKey, assetData);
    }
  }, // All of these `rest.` values must be accessed like this, since ConnectedProviderChild receives `...rest` below.
  // Only ID, type, and url in assetData or token in imsData should trigger re-configuration
  // Be careful in the future that any values added to this list are specifically required for generation of the PGC calls
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [assetData.id, assetData.type, assetData.url, imsData.token, environment, mentionsEnabled, peopleGraphAPIKey, shareStatus]);
};
/**
 * Hook for providing suggestion functionality
 *
 * @export
 * @param {Array} defaultMentions An array of mentions objects for hydrating the initial state (for Edit)
 * @param {String} shareStatus String indicating share status of the asset
 * @returns {Object} An Object containing various suggestions data and methods for fetching suggestions data
 */


exports.useConfigureMentions = useConfigureMentions;

function useMentions() {
  var defaultMentions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  // Track the suggestions returned by the People Graph Client
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      suggestions = _useState2[0],
      setSuggestions = _useState2[1]; // Track the suggestions accepted by the user


  var _useState3 = (0, _react.useState)(defaultMentions),
      _useState4 = _slicedToArray(_useState3, 2),
      acceptedSuggestions = _useState4[0],
      setAcceptedSuggestions = _useState4[1]; // Track the last query made to PGC


  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      lastQuery = _useState6[0],
      setLastQuery = _useState6[1]; // Track whether the last query made to PGC resulted in suggestions


  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      lastQueryResultSucceeded = _useState8[0],
      setLastQueryResultSucceeded = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      queryInProgress = _useState10[0],
      setQueryInProgress = _useState10[1];

  var appContext = (0, _react.useContext)(_AppContext.default);
  var assetData = appContext.assetData,
      shareStatus = appContext.shareStatus;
  /**
   * Handles updates to the text input
   *
   * @param {String} textValue Current value of the text input
   * @param {Number} cursorIndex Current index of the cursor - defaults to end of string
   * @returns {Boolean} Whether the provided input will result in a PGC call
   */

  var getSuggestionsFromInput = (0, _react.useCallback)(function (textValue, cursorIndex) {
    var textBeforeCursor = textValue.substring(0, cursorIndex);
    var lastMentionIndex = (0, _utils.lastIndexOfRegex)(textBeforeCursor, _constants.MENTION_REGEX); // Check if there are any mentions to handle in the text

    if (lastMentionIndex >= 0) {
      // Get the text to check for existing mentions, all text between last @ and cursor position
      var checkText = textBeforeCursor.substring(lastMentionIndex, cursorIndex); // Exit early if multiple spaces are detected in the text to check

      if (checkText.search(/\s{2,}/g) !== -1) {
        return false;
      } // Get any accepted names in the text since the last @ before cursor position


      var namesSinceLastMention = acceptedSuggestions.filter(function (suggestion) {
        return checkText.includes(suggestion.name);
      }); // Set end of accepted suggestion as last mention index if found

      if (namesSinceLastMention.length) {
        lastMentionIndex = lastMentionIndex + namesSinceLastMention[0].name.length;
      } // Discontinue PGC calls if the last query returned zero suggestions on a matching string to current input
      //   For example, if a query "failname" returns 0: "@failname thistextshouldnotresultinaquery"


      if (textValue.substring(lastMentionIndex, cursorIndex).includes(lastQuery) && lastQueryResultSucceeded === false && queryInProgress === false) {
        lastMentionIndex = lastMentionIndex + lastQuery.length;
      } // Now that we have ensured that no existing mentions or failed calls are in the query text, check for an @ symbol


      if (textValue.substring(lastMentionIndex, cursorIndex).indexOf('@') >= 0) {
        // Capture the last query
        setLastQuery(textValue.substring(lastMentionIndex + 1, cursorIndex)); // Run the fetchSuggestions query

        setQueryInProgress(true);
        fetchSuggestions(textValue.substring(lastMentionIndex + 1, cursorIndex), assetData, shareStatus).then(function (response) {
          // Capture whether the last result returned any suggestions
          setLastQueryResultSucceeded(!!response.length); // Set the returned suggestions

          setSuggestions(response);
          setQueryInProgress(false);
        }).catch(function (error) {
          setLastQuery('');
          setLastQueryResultSucceeded(false);
          setSuggestions([]);
          setQueryInProgress(false);
          console.warn(error);
          return false;
        });
        return true;
      }
    }

    return false;
  }, [acceptedSuggestions, lastQuery, lastQueryResultSucceeded, shareStatus, assetData, queryInProgress]);
  /**
   * Sends the accepted suggestion's token to the People Graph Client
   *
   * @param {Object} suggestion The suggestion object to be accepted
   * @returns {Promise} A promise object, resolved after the accepted suggestions have been updated
   */

  var acceptSuggestion = (0, _react.useCallback)(function (suggestion) {
    return peopleGraphClient.acceptTokens([suggestion.token]).then(function (response) {
      if (response && response.error) {
        throw response;
      }

      var acceptData = formatAcceptedSuggestion((0, _lodash.default)(response, 'successes[0]')); // return the suggestion with the provided accept data

      var acceptedSuggestion = _objectSpread(_objectSpread({}, suggestion), acceptData);

      if (acceptedSuggestion.id) {
        // Function to check for acceptedSuggestion.addressBookUrn within a given object
        var checkForAddressBookUrnMatch = function checkForAddressBookUrnMatch(acceptedObject) {
          return acceptedObject.addressBookUrn === acceptedSuggestion.addressBookUrn;
        }; // Ensure that acceptedSuggestion does not duplicate existing entries


        if (!acceptedSuggestions.some(checkForAddressBookUrnMatch)) {
          setAcceptedSuggestions([].concat(_toConsumableArray(acceptedSuggestions), [acceptedSuggestion]));
        }
      }
    }).catch(function (error) {
      console.warn(error);
    });
  }, [acceptedSuggestions]);
  return {
    suggestions: suggestions,
    acceptedSuggestions: acceptedSuggestions,
    getSuggestionsFromInput: getSuggestionsFromInput,
    acceptSuggestion: acceptSuggestion
  };
}